/**
 * 서버가 **200 을 주면서 응답 계약을 어긴** 상태 (TRAD-2365).
 *
 * ## 왜 별도 타입인가
 * 네트워크 끊김·5xx·타임아웃은 **일시적**이라 "잠시 후 다시 시도"가 맞는 안내다.
 * 그런데 `PRICE_PREDICTION` 마켓인데 `assetSymbol`·`targetPrice`·`quoteCurrency`·
 * `priceCondition` 4필드가 통째로 빠져 있는 응답(dev `c9da25d1`)은 **재시도해도 서버가
 * 같은 200 을 다시 준다.** 그런데도 클라는 이것을 일반 실패와 뭉쳐서
 * `error.generic.*`("일시적인 문제가 발생했어요" + "다시 시도")로 안내했다 —
 * **영구 결함을 일시 장애라고 사실과 다르게 말하고, 무한 재시도를 유도**한 것이다.
 *
 * 1세대 인계 메모 §4 "장애를 데이터 없음으로 위장하지 마라" 의 반대 얼굴이다.
 * 방향이 어느 쪽이든 **화면이 사용자에게 거짓말을 하면 안 된다**는 원칙은 같다.
 *
 * ## 규칙
 * - 이 에러는 **재시도 대상이 아니다.** `data-availability` 가 `contract-violation` 으로
 *   분류하고 `isRetryable` 이 false 를 준다 → `ErrorState` 가 재시도 버튼을 주지 않는다.
 * - `message`·`field` 는 **개발자용**이다(영어, 로그 전용). 사용자 노출 문구는 반드시
 *   i18n 카탈로그(`error.contract_violation.*`)를 거친다 — 여기에 t() 를 두지 않는다.
 * - 판정은 **에러 타입**으로 한다. 서버가 이 상태를 알리는 `code` 를 주지 않으므로
 *   `extractErrorCode` 로는 원리적으로 못 잡고, message 문자열 매칭은 깨지기 쉽다.
 */
export class ContractViolationError extends Error {
  /** 계약을 어긴 필드 경로(예: `targetPrice`). 로그·디버깅용 — 사용자에게 노출 금지. */
  readonly field: string;

  constructor(message: string, field: string) {
    super(message);
    this.name = 'ContractViolationError';
    this.field = field;
  }
}

/** 순수 술어. 계약 위반이면 true — 그 밖의 모든 실패(네트워크·5xx·404)는 false. */
export const isContractViolationError = (error: unknown): error is ContractViolationError =>
  error instanceof ContractViolationError;
